module.exports = __webpack_public_path__ + "static/confluence@2x-bdd37dca0377040ca203288cf55615b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/developers/confluence@2x.jpg
// module id = 2553
// module chunks = 168707334958949